import { SafeAreaView, ScrollView } from 'react-native';
import React, { useLayoutEffect } from 'react';
import { useNavigation } from '@react-navigation/native';
import Categories from '../components/Categories';
import Feature from '../components/Feature';
import User_Search from '../components/User_Search';
import { Promo } from '../components/Promo';

const HomeScreen = () => {
  const navigation = useNavigation();

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: false,
    });
  }, []);

  return (
    <SafeAreaView>
      <User_Search />
      <ScrollView>
        <Categories />
        <Feature
          title="Featured"
          description="Enjoy these crazy, juicy and tasty discounts"
        />
        <Promo/>
      </ScrollView>
    </SafeAreaView>
  );
};

export default HomeScreen;
